var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.68,
    height: 66.27,
    viewBox: "0 0 82.683 69.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442",
    transform: "translate(-1203.241 -4248.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M-11551-14717.356s5.842-30.673,25.555-44.7,53.3-11.411,53.3-11.411",
    transform: "translate(12756 19034)",
    fill: "none",
    stroke: "#41a6e9",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M-11490.923-14783.629s17.884,4.344,18.575,10.34-15.811,13.646-15.811,13.646",
    transform: "translate(12757 19034)",
    fill: "none",
    stroke: "#41a6e9",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpArrow);
export default __webpack_public_path__ + "static/media/wp-arrow.c3718eb4b3c55a6a28cce53f27cab541.svg";
export { ForwardRef as ReactComponent };